import { useEffect, useState } from 'react';
import { useSession } from 'next-auth/client';
import { ClientSafeUser } from '@/prisma/utils/user';

export const useUserCanAccess = (user: ClientSafeUser): boolean => {
	const [session, loading] = useSession();
	const [hasAccess, setHasAccess] = useState(false);

	useEffect(() => {		
		if (session) {
			setHasAccess(session.user.id === user.id);
		}
	}, [session]);

	return hasAccess;
};
